import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import CustomDialog from "global/components/CustomDialog/CustomDialog";

interface CustomProps {
  isVisible: boolean;
  handleDialogClose: Function;
  isNavsHide: boolean;
  exit: any;
}

const CustomRouterPrompt = (props: CustomProps) => {
  const theme = useTheme();
  const getDialogHeader = () => {
    return (
      <>
        <Box display="flex" justifyContent="center" pt={3}>
          <Typography variant="h4" color={theme.palette.primary.main}>
            Please confirm
          </Typography>
        </Box>
      </>
    );
  };

  const getBody = () => {
    return (
      <>
        <Box display="flex" flexDirection="column" justifyContent="center">
          <Typography variant="h4" textAlign="center">
            {`${"Want to Discard change"}`}
          </Typography>
          <Typography variant="subtitle2" textAlign="center" pt={1}>
            {`${"You may lose your changes"}`}
          </Typography>
        </Box>
      </>
    );
  };

  const getRouterPromptFooter = () => {
    return (
      <Stack direction="row" spacing={2}>
        <Button
          id="contacts_add_save_btn"
          variant="outlined"
          onClick={() => props.handleDialogClose()}
          sx={{
            width: "7.125rem",
            height: "2.5rem",
          }}
        >
          No
        </Button>
        <Button
          id="contacts_add__cancel_btn"
          variant="contained"
          sx={{
            width: "7.125rem",
            height: "2.5rem",
          }}
          onClick={props.exit}
        >
          Yes
        </Button>
      </Stack>
    );
  };

  return (
    <CustomDialog
      handleDialogClose={props.handleDialogClose}
      isDialogOpen={props.isVisible}
      title={getDialogHeader()}
      body={getBody()}
      footer={getRouterPromptFooter()}
      closeButtonVisibility={true}
      closable
      isNavsHide={props.isNavsHide}
    />
  );
};

export default CustomRouterPrompt;
